import styled from 'styled-components'

import { IconButton, TypeStyle, fromLg, fromMd } from '@syconium/little-miss-figgy'

import { swiperCSS } from '../../../../../lib/shared-styles'

export const Body = styled.div`
  ${swiperCSS}

  position: relative;
  overflow-x: hidden;
  margin-block: ${o => o.theme.spacing(2)};

  // Break out of the CartItemsWrapper padding on the trailing edge only, so the
  // carousel viewport reaches the panel edge and slides bleed off-screen instead
  // of being clipped by the padding. The leading edge stays put, keeping the
  // first slide aligned with the cart content. TitleWrapper re-aligns the title's
  // trailing edge.
  margin-inline-end: ${o => `-${o.theme.spacing(4)}`};

  ${fromMd} {
    margin-inline-end: ${o => `-${o.theme.spacing(10)}`};
  }
`

export const LoadingSpinnerWrapper = styled.div`
  align-items: center;
  display: flex;
  height: 125px;
  justify-content: center;
`

export const TitleWrapper = styled.div`
  display: flex;
  justify-content: space-between;
  margin-bottom: ${o => o.theme.spacing(3)};

  // Re-align the title's trailing edge (carousel controls) with the cart content
  // after Body breaks out of the CartItemsWrapper padding on the trailing edge.
  padding-inline-end: ${o => o.theme.spacing(4)};

  ${fromMd} {
    padding-inline-end: ${o => o.theme.spacing(10)};
  }
`

export const Title = styled(TypeStyle.HeadlineExtraExtraSmall)`
  font-size: 11px;
  line-height: 20px;
`

export const CarouselControlsButtonWrapper = styled.div`
  display: flex;
  gap: ${o => o.theme.spacing(2)};
`

export const StyledIconButton = styled(IconButton)`
  width: 24px;
  height: 24px;
  max-width: 24px;
  max-height: 24px;
  min-width: 24px;
  min-height: 24px;
`

export const UpsellTile = styled.div`
  display: flex;
  background: white;
  border-radius: ${o => o.theme.spacing(2)};
  border: 1px solid ${o => o.theme.color.stroke.neutral.border.decoration.on.background};
  height: 125px;
  min-width: 240px;
  overflow: hidden;
  align-items: stretch;

  ${fromLg} {
    min-width: 308px;
  }
`

export const Thumbnail = styled.div<{
  imgUrl: string
}>`
  background: no-repeat center/contain url(${o => o.imgUrl && o.imgUrl});
  min-width: 125px;
  height: 100%;
`

export const TileContentsWrapper = styled.div`
  display: flex;
  width: 100%;
  line-height: 0;
`

export const Details = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  flex: 1;
  gap: ${o => o.theme.spacing(2)};
  width: 100%;
  padding: ${o => o.theme.spacing(3)};
`

export const DetailsText = styled.div`
  display: flex;
  flex-direction: column;
  gap: ${o => o.theme.spacing(1)};
`

export const ProductName = styled(TypeStyle.HeadlineExtraExtraSmall)`
  font-size: 12px;

  // Limits textbox sizing to 2 lines
  display: -webkit-box;
  -webkit-line-clamp: 2;
  -webkit-box-orient: vertical;
  overflow: hidden;
  text-overflow: ellipsis;
`

export const SizeAndColorText = styled.span`
  ${TypeStyle.css.headlineMicro};
  color: ${o => o.theme.color.stroke.neutral.text.tertiary.on.background};
  display: block;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;

  ${fromMd} {
    ${TypeStyle.css.bodyMicro};
  }
`
